export default "\n.class1 {\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  background-color: red;\n\n\n\n}\n"